import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    box: {
      alignSelf: "stretch",
      border: `1px solid ${theme.gray200}`,
      borderRadius: theme.spacing(2),
      fontSize: "14px",
      margin: theme.spacing(0, 2),
      minHeight: theme.spacing(16),
      overflow: "hidden",
      padding: theme.spacing(3, 5),
      textOverflow: "ellipsis",
    },
    fullWidth: {
      maxWidth: "100% !important",
      width: "100% !important",
    },
    input: {
      flex: 1,
      marginTop: theme.spacing(10),
      maxWidth: 373,
      minWidth: "calc(50% - 12px)",
      width: "100%",
      [theme.breakpoints.up("md")]: {
        marginTop: theme.spacing(0),
        maxWidth: 383,
        width: "auto",
      },
      "& .MuiInputBase-root": {
        background: theme.white50,
      },
    },
    customMemberListInfo: {
      margin: theme.spacing(0, 0, 0, 6),
      width: "100%",
      color: theme.gray500,
      fontSize: "14px",
      lineHeight: "14px",
    },
    campaignCompletionInput: {
      width: "100%",
      "& .MuiInputBase-root": {
        background: theme.white50,
      },
    },
    campaignCompletionWrapper: {
      width: "100%",
      display: "flex",
      alignItems: "center",
    },
    campaignCompletionInfo: {
      fontSize: "14px",
      color: theme.gray500,
    },
    error: {
      border: `1px solid ${theme.red300}`,
      backgroundColor: theme.red50,
      color: theme.red800,
    },
  }),
);
